import { testimonials } from '@/mocks/siteData';
import SectionHeading from '@/components/base/SectionHeading';

export default function TestimonialsSection() {
  return (
    <section className="bg-background-50 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <SectionHeading
            kicker="Voices"
            title="来自合作方与信源的声音"
            description="出于保密考虑，以下反馈均以身份类型代替真实姓名。这也是我们对信息披露的一贯处理方式。"
          />

          <div className="mt-10 md:mt-12 grid grid-cols-1 lg:grid-cols-3 gap-5">
            {testimonials.map((item) => (
              <figure
                key={item.name}
                className="flex flex-col bg-background-100 border border-foreground-950/10 rounded-lg p-6 md:p-7"
              >
                <i className="ri-double-quotes-l text-3xl text-accent-500"></i>
                <blockquote className="mt-4 text-sm md:text-base leading-relaxed text-foreground-800 flex-1">
                  {item.quote}
                </blockquote>
                <figcaption className="mt-6 pt-5 border-t border-foreground-950/10">
                  <p className="font-heading text-sm font-bold text-foreground-950">{item.name}</p>
                  <p className="mt-1 font-mono text-xs text-foreground-500">{item.meta}</p>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}